import { Col, Row } from "react-bootstrap";
import SpecialPlatform from "../../../assets/images/SpecialPlatform.png";
import { AiOutlineWhatsApp } from "react-icons/ai";

function Section5() {
  const whatsappNumber = "+917306569687";

  return (
    <div>
      <br /> <br /> <br /> <br />
      <Row>
        <Col md={6} className="HomeScreen-section5-box1">
          <div className="HomeScreen-section5-text1">
            Switch to the Ultimate Gym Management Platform
          </div>
          <div className="HomeScreen-section5-text2">
            XEntryBook is more than just a time management tool—it's a
            game-changer for your fitness business. Designed to boost revenue
            and provide seamless access to key business metrics, it ensures a
            hassle-free experience for both you and your clients. Make the
            switch to XentryBook and build stronger, long-lasting client
            relationships.
          </div>
          <div>
            <ul className="HomeScreen-section5-list">
              <li>
                <span>Eliminate queues and paperwork at the reception. </span>
              </li>
              <li>
                <span>
                  Never miss a membership renewal with automated reminders.
                </span>
              </li>
              <li>
                <span>
                  {" "}
                  Empower coaches to focus more on training, not admin work.
                </span>
              </li>
              <li>
                <span>
                  Manage clients effortlessly, efficiently, and in real time.
                </span>
              </li>
              <li>
                <span>
                  Ensure 100% data security and restrict unauthorized access.
                </span>
              </li>
            </ul>
            <h6 className="mb-4">
              Upgrade to XEntryBook today and transform the way you run your
              gym!
            </h6>
            {/* Replace button-like WhatsApp link with just the icon, no button styling */}
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="HomeScreen-Whatsapp-Icon"
            >
              <AiOutlineWhatsApp size={42} color="green" />
            </a>
          </div>
        </Col>
        <Col md={6}>
          <img
            src={SpecialPlatform}
            alt=""
            className="HomeScreen-Section5-img"
          />
        </Col>
      </Row>
      <br /> <br />
      <br /> <br />
    </div>
  );
}

export default Section5;
